<template>
    <div>
        <hua-nav-bar
            :title="'访客预约'"
            left-arrow
            @click-left="onClickLeft"
            style="margin-bottom: 10px"
        ></hua-nav-bar>
        <hua-tabs v-model="active" @change="changeTab">
            <hua-tab :title="item" v-for="(item, index) in tabs" :key="index"></hua-tab>
            <epidemic-register
                v-show="active === 0 && isEpidemicInfoRequired && !steps"
                :isEpidemicInfoRequired="isEpidemicInfoRequired"
                :steps="steps"
                @stepsChange="stepsChange"
            ></epidemic-register>
            <booking
                v-show="active === 0 && steps"
                :isEpidemicInfoRequired="isEpidemicInfoRequired"
                :steps="steps"
                :isBooking="true"
                @stepsChange="stepsChange"
            ></booking>
            <my-booking v-if="active === 1 && !isMyList" @onSearch="onSearch"></my-booking>
            <my-booking-list v-if="isListShow && active === 1 && isMyList" :myData="myData"></my-booking-list>
        </hua-tabs>
    </div>
</template>
<script>
import epidemicRegister from './components/epidemicRegister.vue'
import booking from './components/invite.vue'
import myBookingList from '../visitorBooking/components/myBookingList.vue'
import myBooking from './components/myBooking.vue'
// import openUtils from '@/view/photosPeople/openUtils'
import api from '@/constants/api'

export default {
    components: {
        epidemicRegister,
        booking,
        myBooking,
        myBookingList,
    },
    data() {
        return {
            id: null,
            // openId: null,
            active: 0,
            tabs: ['预约来访', '我的预约'],
            isEpidemicInfoRequired: false,
            steps: 0,
            myData: [],
            isMyList: false,
            u_phone:'',
            isListShow: false, // 防止子组件mounted中拿不到值
        }
    },
    methods: {
        // 获取预约列表
        getAppointList(phone){
            this.isListShow = false
            let params = {
                phoneNum: phone,
                pageNum: 1,
                pageSize: 1000,
            }
            api.myAppointmentInfo(params).then((res) => {
                let data = res.data.pageData
                this.isMyList = true
                if (data.length) {
                    this.onSearch(data)
                } else if(this.active === 1){
                    this.$toast.fail('无历史记录')
                }
                this.isListShow = true
            }).catch(err => {
                console.log(err)
                this.isListShow = true
            })
        },
        changeTab(active, title) {
            if (active === 1 && this.u_phone) {
                this.getAppointList(this.u_phone)
            }
            // this.isMyList = false
        },
        stepsChange(step) {
            this.steps = step
        },
        onSearch(data) {
            this.myData = data
            localStorage.setItem('myData', JSON.stringify(this.myData))
            if(data && data.length) {
                this.isMyList = true
                this.isListShow = true
            }
        },
        onClickLeft() {
            // let u_phone = localStorage.getItem("u_phone");
            let accountCode = localStorage.getItem("accountCode")
            let accountState = localStorage.getItem("accountState")
            if (accountCode) {
                accountCode = JSON.parse(accountCode)
                accountState = JSON.parse(accountState)
                this.$router.push({ path: `/log?code=${accountCode}&state=${accountState}` })
            } else {
                this.$router.push({ path: `/log` })
            }
        },
        // 获取微信code和Openid
        // getOpenId(code) {
        //     api.getOpenId(code).then((res) => {
        //         console.log('resres22333', res);
        //         this.openId = res.openid
        //     })
        // }
    },
    mounted() {
        // this.ischat = this.$route.query['ischat'] === 'true' ? true : false
        // if (this.ischat) {
        //     // 访问微信认证页面
        //     openUtils.getCode('photosPeople')
        // }
        // if (this.$route.query['code']) {
        //     // 调用获取openId的接口
        //     this.getOpenId(this.$route.query['code'])
        // }
        // console.log("this.isMyList", this.isMyList, this.active);
        api.getBaseConfig().then((res) => {
            this.isEpidemicInfoRequired = res.data['visitor.epidemic.enable'] ? true : false
            // this.isEpidemicInfoRequired = true
            this.steps = this.isEpidemicInfoRequired ? 0 : 1
        })
        if (this.$route.params.active) {
            this.active = this.$route.params.active
            this.isMyList = this.$route.params.isMyList
            if (this.isMyList) {
                this.myData = JSON.parse(localStorage.getItem('myData'))
                this.onSearch(this.myData)
            }
        }
        this.u_phone = localStorage.getItem("u_phone");
        // 从缓存直接取会有引号""
        isNaN(Number(this.u_phone)) && (this.u_phone = JSON.parse(this.u_phone))
        if (this.u_phone) {
            this.getAppointList(this.u_phone)
        }
    },
}
</script>
